import React, { memo } from "react";
import { NodeProps } from "reactflow";
import { NodeType } from "../../../models/nodeType";
import { FlowNodeWithChildren } from "./FlowNode";

const RollChanceNode: React.FC<NodeProps<NodeType>> = (props) => {
  return <FlowNodeWithChildren {...props} />;
};

export default memo(RollChanceNode);
